import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Spinner } from "@/components/common";
import { Building2, X, Eye } from "lucide-react";

function Modal({ u, onClose, onSaved }) {
  const [ops, setOps] = useState(null);
  const [sel, setSel] = useState(u.empresas_visibles || []);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/users/opciones-empresas").then((r) => setOps(r.data)).catch(() => setOps([])); }, []);
  const toggle = (n) => setSel((s) => (s.includes(n) ? s.filter((x) => x !== n) : [...s, n]));
  const guardar = async () => {
    setBusy(true);
    try { await api.put(`/users/${u.id}/empresas-visibles`, { empresas: sel }); toast.success("Empresas visibles actualizadas"); onSaved(); onClose(); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      <div className="relative z-10 flex max-h-[90vh] w-full max-w-md flex-col rounded-2xl bg-white p-5 shadow-xl" data-testid="visor-empresas-modal">
        <div className="mb-2 flex items-center justify-between"><p className="font-semibold text-slate-800">Empresas que puede ver {u.name}</p><button onClick={onClose} className="rounded p-1 text-slate-400 hover:bg-slate-100" data-testid="visor-empresas-cerrar"><X className="h-5 w-5" /></button></div>
        <p className="mb-3 text-xs text-slate-500">El visor solo ve empleados, expedientes, contratos, terminaciones y certificados de las empresas marcadas. Las empresas nuevas quedan ocultas hasta que las marques.</p>
        {!ops ? <Spinner /> : (
          <div className="flex-1 space-y-1 overflow-y-auto pr-1">
            <div className="mb-2 flex gap-3 text-xs">
              <button onClick={() => setSel(ops)} className="font-semibold text-vino-700" data-testid="visor-empresas-todas">Marcar todas</button>
              <button onClick={() => setSel([])} className="font-semibold text-slate-500" data-testid="visor-empresas-ninguna">Quitar todas</button>
            </div>
            {ops.map((n) => (
              <label key={n} className="flex cursor-pointer items-center gap-2 rounded-lg px-2 py-1.5 text-sm hover:bg-slate-50">
                <input type="checkbox" checked={sel.includes(n)} onChange={() => toggle(n)} className="accent-vino-700" data-testid={`visor-empresa-${n}`} /> {n}
              </label>
            ))}
          </div>
        )}
        <button onClick={guardar} disabled={busy} data-testid="visor-empresas-guardar" className="mt-3 flex items-center justify-center gap-2 rounded-lg bg-vino-700 px-4 py-2 text-sm font-semibold text-white hover:bg-vino-800 disabled:opacity-60">
          {busy && <Spinner />} Guardar ({sel.length} {sel.length === 1 ? "empresa" : "empresas"})
        </button>
      </div>
    </div>
  );
}

export function EmpresasVisorBtn({ u, onSaved }) {
  const [open, setOpen] = useState(false);
  if (u.role !== "visor") return null;
  return (
    <>
      <button onClick={() => setOpen(true)} title="Empresas visibles" data-testid={`visor-empresas-${u.id}`} className="rounded-lg p-2 text-slate-400 hover:bg-vino-50 hover:text-vino-700"><Building2 className="h-4 w-4" /></button>
      {open && <Modal u={u} onClose={() => setOpen(false)} onSaved={onSaved} />}
    </>
  );
}

export function BannerVisor({ user }) {
  if (user?.role !== "visor") return null;
  return (
    <div className="mb-4 flex items-center gap-2 rounded-xl border border-sky-200 bg-sky-50 px-4 py-2 text-sm text-sky-800" data-testid="banner-visor">
      <Eye className="h-4 w-4 shrink-0" /> Modo visor: puedes consultar y descargar, pero no modificar información.
    </div>
  );
}
